<template>
	<div class="appView rapidEamilPage">
		<Sidebar></Sidebar>
		<main class="mainContent teamView">
			<div class="navBar">
				<Hamburger />
				<div class="title">
					Team
				</div>
				<section class="tab">
					<button
						class="user-accounts"
						:class="{ selected: activeTab === 'userAccounts' }"
						@click="toggleTab('userAccounts')"
					>
						User Accounts
					</button>
					<button
						class="receipts"
						:class="{ selected: activeTab === 'receipts' }"
						@click="toggleTab('receipts')"
					>
						<span>Receipts</span>
						<span v-if="reviewReceipts.length > 0" class="notification">{{
							reviewReceipts.length
						}}</span>
					</button>
				</section>
				<button
					v-if="activeTab === 'userAccounts'"
					class="theme-fill-btns"
					@click="handleShowAddMember"
				>
					<img class="plus-icon" src="../../public/svg/plus-icon-white.svg" />
					<span>Add Member</span>
				</button>
				<div class="header-separator"></div>
			</div>
			<Loading :active.sync="isLoading" :is-full-page="fullPage" />

			<section
				v-if="activeTab === 'userAccounts' && !isLoading"
				class="member-list"
			>
				<h4 class="active-members-title">ACTIVE USERS</h4>
				<div class="user-card-wrapper">
					<div v-for="user in activeUsers" :key="user.id" class="user-card">
						<div class="user-detail">
							<span class="username">{{ user.username }}</span>
							<span class="useremail">{{ user.email }}</span>
						</div>
						<div class="user-role">
							<span>{{ user.role }}</span>
							<span v-if="user.isOwner" class="owner-badge">Owner</span>
						</div>
						<div class="actions">
							<button
								v-if="!user.isOwner"
								class="suspend-button"
								title="Suspend the user"
								@click="handleSuspendUser(user.id)"
							>
								<img
									src="../resources/images/icons/team/user-suspend-icon-grey.svg"
									alt=""
								/>
							</button>
							<button
								v-if="!user.isOwner"
								class="email-button"
								title="Send Email Invitation"
								@click="handleInviteUser(user)"
							>
								<img
									src="../resources/images/icons/team/envelope-icon-grey.svg"
									alt=""
								/>
							</button>
							<button
								class="delete-button"
								title="Manage User Details and Role"
								@click="handleManageAccounts"
							>
								<img
									src="../resources/images/icons/team/edit-icon-grey.svg"
									alt=""
								/>
							</button>
						</div>
					</div>
				</div>
				<h4 class="suspended-members-title">SUSPENDED USERS</h4>
				<div class="user-card-wrapper">
					<div v-for="user in suspendedUsers" :key="user.id" class="user-card">
						<div class="user-detail">
							<span class="username">{{ user.username }}</span>
							<span class="useremail">{{ user.email }}</span>
						</div>
						<div class="user-role">
							<span>{{ user.role }}</span>
						</div>
						<div class="actions">
							<button class="restore-button" @click="handleRestoreUser(user)">
								Restore
							</button>
						</div>
					</div>
				</div>
			</section>
			<section
				v-if="activeTab === 'receipts' && !isLoading"
				class="receipt-list"
			>
				<div class="receipt-list-wrapper">
					<h4 class="review-receipts-title">
						<span>REVIEW RECEIPTS</span>
						<button
							v-if="reviewReceipts.length > 0"
							class="approve-all-button"
							@click="handleApproveAllReceipts"
						>
							Approve All
						</button>
					</h4>
					<div v-if="reviewReceipts.length > 0" class="receipts-card-wrapper">
						<div
							v-for="receipt in reviewReceipts"
							:key="receipt.id"
							class="receipts-card"
						>
							<div :class="`category-icon category${receipt.icon}`">
								<div class="icon">
									<div class="glyph"></div>
								</div>
							</div>
							<div class="receipt-detail">
								<span class="vendor">{{ receipt.vendor }}</span>
								<span class="category">{{ receipt.category }}</span>
								<span class="uploader"
									>Uploaded by {{ receipt.uploadedBy }}</span
								>
							</div>
							<div class="receipt-amount">
								{{ toFormatedCurrency(0.0, "$") }}
							</div>
							<div class="actions">
								<button
									class="edit-button"
									@click="handleApproveReceipt(receipt.id)"
								>
									Approve
								</button>
								<button class="edit-button">Delete</button>
							</div>
						</div>
					</div>
					<div v-else class="no-receipts-placeholder">
						<span>No receipts to review. Please upload a new one</span>
					</div>
				</div>
				<div class="receipt-list-wrapper">
					<h4 class="approved-receipts-title">APPROVED RECEIPTS</h4>
					<div v-if="approvedReceipts.length > 0" class="receipts-card-wrapper">
						<div
							v-for="receipt in approvedReceipts"
							:key="receipt.id"
							class="receipts-card"
						>
							<div :class="`category-icon category${receipt.icon}`">
								<div class="icon">
									<div class="glyph"></div>
								</div>
							</div>
							<div class="receipt-detail">
								<span class="vendor">{{ receipt.vendor }}</span>
								<span class="category">{{ receipt.category }}</span>
								<span class="uploader"
									>Approved by {{ receipt.approvedBy }}
									{{ receipt.isCurrentUser ? "(You)" : null }}</span
								>
							</div>
							<div class="receipt-amount">
								{{ toFormatedCurrency(0.0, "$") }}
							</div>
							<div class="actions">
								<button
									class="edit-button"
									@click="handleUnApproveReceipt(receipt.id)"
								>
									UnApprove
								</button>
								<button class="edit-button">Delete</button>
							</div>
						</div>
					</div>
					<div v-else class="no-receipts-placeholder">
						<span>
							No approved receipts. Please upload a new one and review it.
						</span>
					</div>
				</div>
			</section>
			<expense-report-content v-if="activeTab === 'expenseReport'" />
			<add-member
				v-if="showAddMember"
				@close="handleCloseAddMember"
				@insertNewUser="handleInsertNewUser"
			/>
			<manage-member v-if="showManageMember" @close="handleCloseManageMember" />
			<user-suspend-confirm
				v-if="showConfirmSuspend"
				@close="showConfirmSuspend = false"
				@suspendTheUser="handleSubmitSuspendUser"
			/>
			<user-invite-confirm
				v-if="showConfirmInvite"
				@close="showConfirmInvite = false"
				:userDetailsToInvite="userDetailsToInvite"
			/>
			<user-restore-confirm
				v-if="showConfirmRestore"
				@close="showConfirmRestore = false"
				:restoringUserDetails="restoringUserDetails"
				@submitUserRestore="restoreTheUser"
			/>
		</main>
	</div>
</template>

<script>
import Loading from "vue-loading-overlay";
import { getUserId } from "../utils/auth";
import Sidebar from "../components/Sidebar.vue";
import Hamburger from "../components/Hamburger.vue";
import AddMember from "../components/team/CreateTeamMember.vue";
import ManageMember from "../components/team/ManageTeamMember.vue";
import UserSuspendConfirm from "../components/team/UserSuspendConfirm.vue";
import UserInviteConfirm from "../components/team/UserInviteConfirm.vue";
import UserRestoreConfirm from "../components/team/UserRestoreConfirm.vue";
import ExpenseReportContent from "../components/team/ExpenseReportContent.vue";

export default {
	data() {
		return {
			userRapidEmail: "",
			isLoading: false,
			fullPage: false,
			isEmailCopySuccess: false,
			emailCopyResponseMessage: "",
			showAddMember: false,
			isNewUserAdded: false,
			activeTab: "userAccounts",
			showManageMember: false,
			showConfirmSuspend: false,
			showConfirmInvite: false,
			showConfirmRestore: false,
			currentUserIndex: null,
			userDetailsToInvite: null,
			restoringUserDetails: null,
			activeUsers: [
				{
					id: Math.random(),
					username: "Admin Zaw Thet",
					email: "adminzawthet@example.com",
					role: "Administrator",
					isOwner: true
				},
				{
					id: Math.random(),
					username: "Approver Zaw Thet",
					email: "approverzawthet@example.com",
					role: "Expense Approver",
					isOwner: false
				},
				{
					id: Math.random(),
					username: "Basic Zaw Thet",
					email: "basiczawthet@example.com",
					role: "Basic User",
					isOwner: false
				}
			],
			suspendedUsers: [
				{
					id: Math.random(),
					username: "Suspended Zaw Thet",
					email: "suspendedzawthet@example.com",
					role: "Suspended User",
					isOwner: false
				},
				{
					id: Math.random(),
					username: "Suspended Zaw Thet",
					email: "suspendedzawthet@example.com",
					role: "Suspended User",
					isOwner: false
				},
				{
					id: Math.random(),
					username: "Suspended Zaw Thet",
					email: "suspendedzawthet@example.com",
					role: "Suspended User",
					isOwner: false
				},
				{
					id: Math.random(),
					username: "Suspended Zaw Thet",
					email: "suspendedzawthet@example.com",
					role: "Suspended User",
					isOwner: false
				},
				{
					id: Math.random(),
					username: "Suspended Zaw Thet",
					email: "suspendedzawthet@example.com",
					role: "Suspended User",
					isOwner: false
				},
				{
					id: Math.random(),
					username: "Suspended Zaw Thet",
					email: "suspendedzawthet@example.com",
					role: "Suspended User",
					isOwner: false
				},
				{
					id: Math.random(),
					username: "Suspended Zaw Thet",
					email: "suspendedzawthet@example.com",
					role: "Suspended User",
					isOwner: false
				},
				{
					id: Math.random(),
					username: "Suspended Zaw Thet",
					email: "suspendedzawthet@example.com",
					role: "Suspended User",
					isOwner: false
				}
			],
			reviewReceipts: [
				{
					id: Math.random(),
					vendor: "Main Street Restaurant",
					category: "Other Expenses",
					uploadedBy: "Approver Zaw Thet",
					approvedBy: "Admin Zaw Thet",
					isCurrentUser: true,
					icon: "Other"
				},
				{
					id: Math.random(),
					vendor: "Kellari New York",
					category: "Meals & Entertainment",
					uploadedBy: "Basic Zaw Thet",
					approvedBy: "Admin Zaw Thet",
					isCurrentUser: true,
					icon: "MealsEntertainment"
				},
				{
					id: Math.random(),
					vendor: "COSTCO WHOLESALE",
					category: "Office Supplies",
					uploadedBy: "Suspended Zaw Thet",
					approvedBy: "Admin Zaw Thet",
					isCurrentUser: true,
					icon: "OfficeSupplies"
				}
			],
			approvedReceipts: [
				{
					id: Math.random(),
					vendor: "Marriott's Aruba Surf Club",
					category: "Travel",
					uploadedBy: "Suspended Zaw Thet",
					approvedBy: "Admin Zaw Thet",
					isCurrentUser: true,
					icon: "Flights"
				},
				{
					id: Math.random(),
					vendor: "Anchorpoint",
					category: "Office Supplies",
					uploadedBy: "Approver Zaw Thet",
					approvedBy: "Approver Zaw Thet",
					isCurrentUser: false,
					icon: "OfficeSupplies"
				},
				{
					id: Math.random(),
					vendor: "Marriott's Aruba Surf Club",
					category: "Travel",
					uploadedBy: "Basic Zaw Thet",
					approvedBy: "Admin Zaw Thet",
					isCurrentUser: true,
					icon: "Flights"
				},
				{
					id: Math.random(),
					vendor: "Anchorpoint",
					category: "Office Supplies",
					uploadedBy: "New Basic Zaw Thet",
					approvedBy: "Approver Zaw Thet",
					isCurrentUser: false,
					icon: "OfficeSupplies"
				},
				{
					id: Math.random(),
					vendor: "Marriott's Aruba Surf Club",
					category: "Travel",
					uploadedBy: "Admin Zaw Thet",
					approvedBy: "Admin Zaw Thet",
					isCurrentUser: true,
					icon: "Flights"
				},
				{
					id: Math.random(),
					vendor: "Anchorpoint",
					category: "Office Supplies",
					uploadedBy: "Approver Zaw Thet",
					approvedBy: "Approver Zaw Thet",
					isCurrentUser: false,
					icon: "OfficeSupplies"
				}
			]
		};
	},
	components: {
		Sidebar,
		Loading,
		Hamburger,
		AddMember,
		ManageMember,
		UserSuspendConfirm,
		UserInviteConfirm,
		UserRestoreConfirm,
		ExpenseReportContent
	},
	async mounted() {
		await this.waitUserListFetching;
	},
	methods: {
		waitTwoMinutes() {
			return new Promise((resolve, reject) =>
				setTimeout(() => {
					return Math.random() > 0.5 ? resolve() : reject();
				}, 2000)
			);
		},
		async waitUserListFetching() {
			try {
				this.isLoading = true;
				await this.waitTwoMinutes();
			} catch (error) {
				return error;
			} finally {
				this.isLoading = false;
			}
		},
		handleShowAddMember() {
			this.showAddMember = true;
		},
		handleCloseAddMember() {
			this.showAddMember = false;
		},
		async handleInsertNewUser() {
			try {
				this.activeUsers.push({
					id: Math.random(),
					username: "New Basic Zaw Thet",
					email: "newbasiczawthet@example.com",
					role: "Basic User",
					isOwner: false
				});
				await this.waitUserListFetching();
			} catch (error) {
				return error;
			}
		},
		toggleTab(tab) {
			this.activeTab = tab;
		},
		handleManageAccounts() {
			this.showManageMember = true;
		},
		handleCloseManageMember() {
			this.showManageMember = false;
		},
		handleApproveReceipt(receiptId) {
			const [receiptToApprove] = this.reviewReceipts.filter(
				receipt => receipt.id === receiptId
			);
			this.approvedReceipts.unshift(receiptToApprove);
			this.reviewReceipts = this.reviewReceipts.filter(
				receipt => receipt.id !== receiptId
			);
		},
		handleApproveAllReceipts() {
			this.approvedReceipts = [
				...this.reviewReceipts,
				...this.approvedReceipts
			];
			this.reviewReceipts = [];
		},
		handleUnApproveReceipt(receiptId) {
			const [receiptToUnApprove] = this.approvedReceipts.filter(
				receipt => receipt.id === receiptId
			);
			this.reviewReceipts.unshift(receiptToUnApprove);
			this.approvedReceipts = this.approvedReceipts.filter(
				receipt => receipt.id !== receiptId
			);
		},
		handleSuspendUser(userIndex) {
			this.showConfirmSuspend = true;
			this.currentUserIndex = userIndex;
		},
		handleSubmitSuspendUser() {
			const [userToSuspend] = this.activeUsers.filter(
				user => user.id === this.currentUserIndex
			);
			this.suspendedUsers = [userToSuspend, ...this.suspendedUsers];
			this.activeUsers = this.activeUsers.filter(
				user => user.id !== this.currentUserIndex
			);
			this.showConfirmSuspend = false;
		},
		handleRestoreUser(userDetails) {
			this.restoringUserDetails = userDetails;
			this.showConfirmRestore = true;
		},
		handleInviteUser(userDetails) {
			this.userDetailsToInvite = userDetails;
			this.showConfirmInvite = true;
		},
		restoreTheUser() {
			const [userToRestore] = this.suspendedUsers.filter(
				user => user.id === this.restoringUserDetails.id
			);
			this.activeUsers = [...this.activeUsers, userToRestore];
			this.suspendedUsers = this.suspendedUsers.filter(
				user => user.id !== this.restoringUserDetails.id
			);
			this.showConfirmRestore = false;
		}
	}
};
</script>
